import { Box, Chip, Typography } from "@mui/material"
import type { FC } from "react"

interface PalletInfoHeaderProps {
  productName: string
  referenceId: number
}

export const PalletInfoHeader: FC<PalletInfoHeaderProps> = ({ productName, referenceId }) => {
  return (
    <Box className='mb-4 flex items-center gap-2'>
      <Typography variant='body1' className='font-medium'>
        {productName}
      </Typography>
      <Chip label={`Ref ID: ${referenceId}`} size='small' className='rounded bg-yellow-300 text-tertiary-base' />
    </Box>
  )
}
